import Bucket from './Bucket.js';

const PREPAID_VOICE_AIRTIME_ID = 'DWH_VOICE_AIRTIME';
const PREPAID_MESSAGES_AIRTIME_ID = 'DWH_MESSAGES_AIRTIME';
const PREPAID_DATA_AIRTIME_ID = 'DWH_DATA_AIRTIME';
const PREPAID_PACKAGES_AIRTIME_ID = 'DWH_PACKAGES_AIRTIME';
const PREPAID_AIRTIME_CONSUMPTION_BUCKETS = [
  PREPAID_VOICE_AIRTIME_ID,
  PREPAID_MESSAGES_AIRTIME_ID,
  PREPAID_DATA_AIRTIME_ID,
  PREPAID_PACKAGES_AIRTIME_ID,
];

export default class PrepaidBucket extends Bucket {
  /**
   * @return {boolean}
   */
  get isDetail() {
    return !this.isSummary && !this.isAirtime && !this.isCredit && !this.isBonusCredit;
  }

  /**
   * A completely empty bucket is one that has 0 size, 0 usage and 0 remaining.
   *
   * @return {boolean}
   */
  get isEmpty() {
    return !this.total && !this.used && !this.remaining;
  }

  /**
   * @return {boolean}
   */
  get isMerged() {
    return !this.total && this.remaining > 0;
  }

  /**
   * @return {boolean}
   */
  get isVoiceAirtime() {
    return this.id === PREPAID_VOICE_AIRTIME_ID;
  }

  /**
   * @return {boolean}
   */
  get isMessagesAirtime() {
    return this.id === PREPAID_MESSAGES_AIRTIME_ID;
  }

  /**
   * @return {boolean}
   */
  get isDataAirtime() {
    return this.id === PREPAID_DATA_AIRTIME_ID;
  }

  /**
   * @return {boolean}
   */
  get isPackagesAirtime() {
    return this.id === PREPAID_PACKAGES_AIRTIME_ID;
  }

  /**
   * @return {boolean}
   */
  get isOutsidePackagesAirtime() {
    return this.isVoiceAirtime || this.isMessagesAirtime || this.isDataAirtime;
  }

  /**
   * @return {boolean}
   */
  get isAirtime() {
    return PREPAID_AIRTIME_CONSUMPTION_BUCKETS.includes(this.id);
  }
}
